import {
  Box,
  Flex,
  Text,
  useColorMode,
  useColorStyle,
  Icon,
  Space,
  Button,
  Divider,
  Link,
} from '@tonic-one/react';
import { SpamOIcon, VirusIcon } from '@tonic-one/react-icons';
import config from 'src/config';
import React, { useEffect, useState } from 'react';
import { GlobalApi } from '@Apis';
import { formatNumberWithUnit } from '@Utils/common';
import { IS_UAE } from '@Utils/const';
import { Trans, useTranslation } from 'react-i18next';
import { CAS_DOC_LINK, getCasOLHLink } from '@Utils/casDocLink';
import i18next from 'i18next';
export const Summary = ({
  setLoading,
}: {
  setLoading: (load: boolean) => void;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const [data, setData] = useState<{
    detectedThreatNum: string;
    scannedMailFileNum: string;
  }>({
    detectedThreatNum: '0',
    scannedMailFileNum: '0',
  });

  useEffect(() => {
    (async function doCall() {
      try {
        setLoading(true);
        const data = (await GlobalApi.getLiveDashboard()).data;
        if (!data) return;
        setData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [setLoading]);

  return (
    <Box>
      <Flex alignItems="stretch" flexDirection="row">
        <Box flex="auto" color={colorStyle.color.primary}>
          <Text
            fontSize="42px"
            lineHeight="52px"
            color={colorStyle.color.primary}
            dangerouslySetInnerHTML={{
              __html: !IS_UAE
                ? t('common.productName')
                : 'Cyber Eye Cloud Service Security',
            }}
          ></Text>
          <Text
            mt={16}
            fontSize="28px"
            lineHeight="36px"
            color={colorStyle.color.secondary}
          >
            {t('login.summary.subTitle')}
          </Text>
          <Flex
            alignItems="stretch"
            justifyContent="flex-start"
            height={120}
            mt={32}
          >
            <Box flex="auto" width={193}>
              <Flex flexDirection="column" textAlign="center">
                <Text lineHeight="md">
                  <Icon as={VirusIcon} size="32px" />
                </Text>
                <Space height="2x" />
                <Text
                  color={colorStyle.color.primary}
                  fontSize="28px"
                  lineHeight="32px"
                  height="56px"
                >
                  {
                    formatNumberWithUnit(data.detectedThreatNum.toString())
                      .dispstring
                  }
                </Text>
                <Text color={colorStyle.color.secondary} fontSize="16px">
                  {t(
                    'welcome.enableCloudEmailAndCollaborationProtection.icon1.desc'
                  )}
                </Text>
              </Flex>
            </Box>
            <Divider variant="solid" orientation="vertical" />
            <Box flex="auto" width={316} mr="4x">
              <Flex flexDirection="column" textAlign="center">
                <Text fontSize="md" lineHeight="md">
                  <Icon as={SpamOIcon} size="32px" />
                </Text>
                <Space height="2x" />
                <Text
                  color={colorStyle.color.primary}
                  fontSize="28px"
                  lineHeight="32px"
                  height="56px"
                >
                  {
                    formatNumberWithUnit(data.scannedMailFileNum.toString())
                      .dispstring
                  }
                </Text>
                <Text color={colorStyle.color.secondary} fontSize="16px">
                  {t(
                    'welcome.enableCloudEmailAndCollaborationProtection.icon2.desc'
                  )}
                </Text>
              </Flex>
            </Box>
          </Flex>
          <Text
            mt={34}
            fontSize="18px"
            lineHeight="24px"
            color={colorStyle.color.primary}
          >
            {t('login.summary.desc')}
          </Text>
          <Text
            mt={16}
            fontSize="16px"
            lineHeight="22px"
            color={colorStyle.color.secondary}
          >
            {t('login.summary.desc2')}
          </Text>
          {!IS_UAE && (
            <Flex alignItems="stretch" justifyContent="flex-start" mt={22}>
              <Button
                variant="secondary"
                onClick={() => {
                  window.location.href = config.ui.loginPage.startFreeTrail;
                }}
              >
                {t('login.summary.startFreeTrial')}
              </Button>
              <Button
                variant="secondary"
                ml={8}
                onClick={() => {
                  window.location.href = config.ui.loginPage.contactReseller;
                }}
              >
                {t('login.summary.contactReseller')}
              </Button>
            </Flex>
          )}
          <Box mt={16}>
            <Trans i18nKey="login.learnMore.link">
              placeholder
              <Link
                href={getCasOLHLink(CAS_DOC_LINK.about, i18next.language)}
                target="_blank"
              >
                placeholder
              </Link>
              placeholder
            </Trans>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};
